/**
 * Detects whether the app is running inside an iframe.
 */
export function useIsIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // If accessing window.top throws (cross-origin), we're in an iframe
    return true;
  }
}
